var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editMode)?_c('DocumentPage',{attrs:{"page":_vm.page}}):(!_vm.loadedPage || !_vm.pageInVisibleRange(_vm.page))?_c('DummyPage',{attrs:{"width":_vm.page.size[0],"height":_vm.page.size[1]}}):_c('DocumentPage',{attrs:{"page":_vm.loadedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }